// Simple category icon fallback using emojis. Extend as needed.
export function getCategoryIcon(name = '') {
  const key = String(name).trim().toLowerCase();
  const map = {
    electronics: '🔌',
    mobiles: '📱',
    phone: '📱',
    smartphone: '📱',
    accessories: '🎧',
    fashion: '👗',
    clothing: '👕',
    men: '👔',
    women: '👗',
    beauty: '💄',
    grocery: '🛒',
    home: '🏠',
    furniture: '🛋️',
    kitchen: '🍳',
    appliances: '🧺',
    sports: '🏀',
    fitness: '🏋️',
    toys: '🧸',
    baby: '🍼',
    books: '📚',
    stationery: '🖊️',
    jewelry: '💍',
    automotive: '🚗',
    health: '⚕️',
  };
  return map[key] || '🏷️';
}
